<template>
    <div v-loading="loading">
        <h1 class="title">
            <span class="sub-title active">选择项目</span>
        </h1>
        <el-form ref="ruleForm" :rules="rules" :model="ruleForm">
            <el-form-item v-if="projects.length" prop="projectId" class="select-drop">
                <el-select v-model="ruleForm.projectId" placeholder="请选择项目">
                    <el-option
                            v-for="(item, index) in projects"
                            :label="item.text"
                            :value="item.value"
                            :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-top: 50px">
                <el-button type="primary" size="large" style="width:100%" @click="submitForm('ruleForm')">进入项目
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script type="text/javascript">
    export default {
        name: 'project',
        props: {
            projects: Array
        },
        data () {
            return {
                url: '/loginProject.api',
                ruleForm: {
                    projectId: ''
                },
                rules: {
                    projectId: [{required: true, message: '请选择项目', trigger: 'blur,change'}]
                },
                loading: false
            }
        },
        methods: {
            submitForm (form) {
                this.$refs[form].validate((vaild) => {
                    if (vaild) {
                        this.loading = true
                        this.$axios.post(this.url, this.ruleForm, {'X-loadingOff': true}).then((res) => {
                            this.loading = false
                            this.$emit('success', res)
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        console.log('not valid')
                        return false
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// project.vue?795c03c0